import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { ExternalLibraryFacade } from "@hermes/hermes-web-states-external-library-state";

const LIBRARY_KEY = "RISKIFIED_BEACON";
@Injectable()
export class LoadRiskifiedBeaconLibraryService {
    private externalLibraryFacade = inject(ExternalLibraryFacade);

    public isLoaded$: Observable<boolean> =
        this.externalLibraryFacade.isLoaded$(LIBRARY_KEY);

    public isError$: Observable<boolean> =
        this.externalLibraryFacade.isError$(LIBRARY_KEY);

    public load(shop: string, id: string): void {
        this.externalLibraryFacade.load({
            url: `https://beacon.riskified.com?shop=${shop}&sid=${id}`,
            windowAttribute: "RISKX",
            key: LIBRARY_KEY,
        });
    }
}
